import {
  GROUP_AB_TEST,
  GROUP_CONJOINT,
  GROUP_VAN_WESTENDORP,
  GROUP_MAXDIFF,
} from 'data/nodeTypes';

export const DIVIDER_COLORS = {
  [GROUP_AB_TEST]: '#c7d6d4',
  [GROUP_CONJOINT]: '#e1d7cb',
  [GROUP_MAXDIFF]: '#b3d1dc',
  [GROUP_VAN_WESTENDORP]: '#cdc8d7',
};
